import { ArsenalInventory } from '@components/arsenal/inventory/ArsenalInventory';
import { PlayerMarket } from '@components/arsenal/playerMarket/PlayerMarket';
import { ArsenalChassis } from '@components/arsenal/chassis/ArsenalChassis';
import { ArsenalWeapons } from '@components/arsenal/weapons/ArsenalWeapons';
import { ArsenalTutorial } from '@components/tutorial/ArsenalTutorial';
import { ArsenalForge } from '@components/arsenal/forge/ArsenalForge';
import { ArsenalSidebar } from '@components/arsenal/ArsenalSidebar';
import { ArsenalMods } from '@components/arsenal/mods/ArsenalMods';
import { Market } from '@components/arsenal/market/Market';
import { useAppStore } from '@stores';

export function Arsenal() {
  const { arsenalTab } = useAppStore();

  return (
    <div className="flex h-full">
      <ArsenalTutorial />
      <ArsenalSidebar />

      <div className="flex-1 overflow-y-auto">
        {arsenalTab === 'playerMarket' && <PlayerMarket />} 
        {arsenalTab === 'chassis' && <ArsenalChassis />}
        {arsenalTab === 'weapons' && <ArsenalWeapons />}
        {arsenalTab === 'items' && <ArsenalInventory />}
        {arsenalTab === 'forge' && <ArsenalForge />}
        {arsenalTab === 'mods' && <ArsenalMods />}
        {arsenalTab === 'market' && <Market />}
      </div>
    </div>
  );
}